import { render, staticRenderFns } from "./TeamInvite.vue?vue&type=template&id=780b6d85"
import script from "./TeamInvite.vue?vue&type=script&lang=js"
export * from "./TeamInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports